import { createApp } from '@backstage/frontend-defaults';
import authPlugin from '@backstage/plugin-auth';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import { techDocsMermaidAddonModule } from 'backstage-plugin-techdocs-addon-mermaid';
import { pluginInfoResolver } from './pluginInfoResolver';

import {
  apiDocsModule,
  appModule,
  catalogEntityModule,
  catalogModule,
  catalogGraphModule,
  catalogImportModule,
  devToolsModule,
  githubActionsModule,
  graphiqlModule,
  homeModule,
  insightsModule,
  scaffolderModule,
  searchModule,
  soundcheckModule,
  techdocsModule,
  userSettingsModule,
} from './modules';

const app = createApp({
  advanced: {
    pluginInfoResolver,
  },
  features: [
    authPlugin,
    apiDocsModule,
    appModule,
    catalogEntityModule,
    catalogModule,
    catalogGraphModule,
    catalogImportModule,
    devToolsModule,
    githubActionsModule,
    graphiqlModule,
    homeModule,
    insightsModule,
    scaffolderModule,
    searchModule,
    signalsPlugin,
    soundcheckModule,
    techdocsModule,
    techDocsMermaidAddonModule,
    userSettingsModule,
  ],
});

export default app.createRoot();
